<template>
    <ul class="nav--products">
        <router-link tag="li" :to="{ name: 'Clients Connections Products' }" :class="{'active': this.$route.name === 'Clients Connections Products'}">
            <a href="#">{{ t('clients.connections.synchronized') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Products Logs' }" :class="{'active': this.$route.name === 'Clients Connections Products Logs'}">
            <a href="#">{{ t('clients.connections.products.notifications') }}</a>
        </router-link>
    </ul>
</template>

<script>

export default {
    name: 'ProductMenu',

    props: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},
};
</script>

<style lang="scss" scoped>

    a {
        padding-bottom: 1px;
    }

    a:hover {
        text-decoration: none !important;
    }

    li:hover {
        border: 0px;
    }


</style>
